import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-stream-tile',
  templateUrl: './stream-tile.component.html',
  styleUrls: ['./stream-tile.component.scss']
})
export class StreamTileComponent implements OnInit {
  @Input('stream') stream;
  @Input('inSlider') inSlider;

  constructor() { }

  ngOnInit() {
    this.streamCPD();
    this.streamMeta();
  }

  streamCPD(){
    this.stream.minutes=0;
    this.stream.active_courses.forEach((data, index) => {
      this.stream.minutes+=data.course.points;
    });
  }

  streamMeta(){
    this.stream.completed_courses=0;
    this.stream.active_courses.forEach(course => {
      if(course.course.meta) this.stream.completed_courses+=course.course.meta.length;
    });
  }
}
